<div class="routine-check shadow-l rounded-2 mb-3 d-flex <%= isChecked ? 'checked' : '' %>"
     style="position: relative"
     data-type="routine-selection">
  <% if ( goal === "weekly" )  { %>
    <div style="position: absolute; left: 40px; width: calc( 100% - 80px); height: 5px; bottom: 4px; background-color: #cdcdcd;border-radius: 5px">
      <div data-id="progress-bar"
           style="background:linear-gradient(-47deg, #80c6e2 0%, #4eb9aa 100%)!important;;height: 3px; width: <%= percentage %>%;margin-top: 1px; transition: width 1s ease-in-out;"></div>
    </div>
  <% }  %>
  <div class="align-self-center" style="min-width: 40px">
    <% if ( icon ) {  %>
      <img src="/assets/icons/routines/<%= icon %>" style="max-width: 18px; margin-left: 11px; margin-bottom: 4px;" />
    <% }  %>
  </div>
  <div class="align-self-center routine-name <%= ( goal === 'weekly' ) ? '' : 'routine-name-tocross' %>">
    <%= name %>
  </div>
  <div class="ms-auto ps-3 align-self-center text-center" style="min-width: 50px!important;">
    <i class="fa-regular fa-square"></i>
    <i class="far fa-square-check"></i>
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
</div>
